import React from "react";
import PropTypes from "prop-types";
import { CustomerSatisfactionSection } from "./completeJob/CustomerSatisfactionSection";
import { ProductSerialsSection } from "./completeJob/ProductSerialsSection";
import { BenchmarkSection } from "./completeJob/BenchmarkSection";
import { GasSignOffSection } from "./completeJob/GasSignOffSection";
import { ElectricalSignOffSection } from "./completeJob/ElectricalSignOffSection";
import { InstallationImagesSection } from "./completeJob/InstallationImagesSection";
import { FinanceSatisfactionNoteSection } from "./completeJob/FinanceSatisfactionNoteSection";
import responseTypes from "../../utils/responseTypes";

const types = responseTypes();

export function CompleteJobMenu({
  jobToComplete,
  submitSatisfactionHandler,
  productSerialsHandler,
  benchmarkSubmitHandler,
  uploadBenchmarkToClientFunc,
  gasSignOffHandler,
  uploadCP1ToClientFunc,
  electricalSignOffHandler,
  installationImageSignOffHandler,
  addInstallationImageToJob,
  removeInstallationFromJob,
  uploadingImages,
  financeNoteHandler,
  errorMessage,
  setError,
}) {
  const isFinanceOrder = jobToComplete?.paymentType === types.PAYMENT_FINANCE;

  return (
    <div className="row">
      <div className="col-xs-12">
        <div className="accordion" id="menuAccordion">
          <CustomerSatisfactionSection
            jobToComplete={jobToComplete}
            submitSatisfactionHandler={submitSatisfactionHandler}
            setError={setError}
            errorMessage={errorMessage}
          />
          <ProductSerialsSection
            jobToComplete={jobToComplete}
            productSerialsHandler={productSerialsHandler}
            errorMessage={errorMessage}
          />
          <BenchmarkSection
            jobToComplete={jobToComplete}
            benchmarkSubmitHandler={benchmarkSubmitHandler}
            uploadBenchmarkToClientFunc={uploadBenchmarkToClientFunc}
            errorMessage={errorMessage}
          />
          <GasSignOffSection
            jobToComplete={jobToComplete}
            gasSignOffHandler={gasSignOffHandler}
            uploadCP1ToClientFunc={uploadCP1ToClientFunc}
            errorMessage={errorMessage}
          />
          <ElectricalSignOffSection
            jobToComplete={jobToComplete}
            electricalSignOffHandler={electricalSignOffHandler}
            errorMessage={errorMessage}
          />
          <InstallationImagesSection
            jobToComplete={jobToComplete}
            installationImageSignOffHandler={installationImageSignOffHandler}
            addInstallationImageToJob={addInstallationImageToJob}
            removeInstallationFromJob={removeInstallationFromJob}
            uploadingImages={uploadingImages}
            errorMessage={errorMessage}
          />
          {isFinanceOrder && (
            <FinanceSatisfactionNoteSection
              jobToComplete={jobToComplete}
              financeNoteHandler={financeNoteHandler}
              setError={setError}
              errorMessage={errorMessage}
            />
          )}
        </div>
      </div>
    </div>
  );
}

CompleteJobMenu.propTypes = {
  jobToComplete: PropTypes.object,
  submitSatisfactionHandler: PropTypes.func,
  productSerialsHandler: PropTypes.func,
  benchmarkSubmitHandler: PropTypes.func,
  uploadBenchmarkToClientFunc: PropTypes.func,
  gasSignOffHandler: PropTypes.func,
  uploadCP1ToClientFunc: PropTypes.func,
  electricalSignOffHandler: PropTypes.func,
  installationImageSignOffHandler: PropTypes.func,
  addInstallationImageToJob: PropTypes.func,
  removeInstallationFromJob: PropTypes.func,
  uploadingImages: PropTypes.array,
  financeNoteHandler: PropTypes.func,
  errorMessage: PropTypes.array,
  setError: PropTypes.func,
};
